import { connect } from 'react-redux';
import Notification from './Notification';
import { createStructuredSelector } from 'reselect';
import { getNotification } from './Notification.selectors';
import { actions } from './Notification.actions';

const mapStateToPropsSelectors = createStructuredSelector({
    item: getNotification
});

const NotificationComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.notification.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            init: actions.initNotification,
            close: actions.close
        };
    }
)(Notification);

export default NotificationComponent;
